module.exports = __webpack_public_path__ + "img/sld_dcdb_b1.47f8816e.svg";